export default "__VITE_ASSET__DN1qIML8__"